import React from "react";
import { connect } from "react-redux";
import { Droppable } from "react-beautiful-dnd";
import Column from "./Column";

const Columns = props => {
    const { columns } = props;

    return <Droppable
        droppableId="main"
        type="column"
        direction="horizontal"
    >
        {(provided, snapshot) => (
            <div className={`row kanban-main crewContainer_main ${snapshot.isDraggingOver ? "dragging-over" : ""}`}
                ref={provided.innerRef}
                {...provided.droppableProps}>
                {columns.map((column, index) => <Column key={column.columnId}
                    columnId={column.columnId}
                    crewId={column.crewId}
                    index={index}
                />)}
                {provided.placeholder}
            </div>)}
    </Droppable>;
};

const mapStateToProps = state => ({
    columns: state.crewKanban.columns
});

export default connect(mapStateToProps)(Columns);